import { pickKlineInterval } from "@helpers/futures/klines";
import {
  CHART_VIEW,
  LINE_CHART_MAX_CANDLES,
  MAX_TRADE_CANDLES,
} from "../constants";

/**
 * Interval of the trade's candles and how many of them it lasted.
 * @param {number} openedAt ms
 * @param {number} endTime ms, the close or now
 */
export const getTradeCandleRange = (openedAt, endTime) => {
  const { interval, ms } = pickKlineInterval(
    endTime - openedAt,
    MAX_TRADE_CANDLES,
  );
  const count = Math.floor(endTime / ms) - Math.floor(openedAt / ms) + 1;

  return { interval, ms, count };
};

/**
 * CHART_VIEW of a trade: a one-candle trade has no chart to show,
 * a few candles read better as a line.
 * @param {number|null} openedAt ms
 * @param {number} endTime ms
 */
export const getChartView = (openedAt, endTime) => {
  if (openedAt == null) return CHART_VIEW.SUMMARY;

  const { count } = getTradeCandleRange(openedAt, endTime);

  if (count <= 1) return CHART_VIEW.SUMMARY;
  if (count <= LINE_CHART_MAX_CANDLES) return CHART_VIEW.LINE;

  return CHART_VIEW.CANDLES;
};
